var React = require('react');

function Diploma332px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M31 21.962h-2a.999.999 0 1 1 0-1.996h1V2.002H2V20.03h13c.553 0 1 .383 1 .933a.999.999 0 0 1-1 .999H1c-.553 0-1-.447-1-.999V1.004a.999.999 0 0 1 1-.998h30c.553 0 1 .447 1 .998v19.959a.999.999 0 0 1-1 .999zm-9-10.979c2.757 0 5 2.239 5 4.991a4.934 4.934 0 0 1-1.005 2.969c0 .009.005.016.005.025v5.988a1 1 0 0 1-1.555.83L22 24.159l-2.445 1.627a1.002 1.002 0 0 1-1.555-.83v-5.988c0-.009.005-.016.005-.025A4.934 4.934 0 0 1 17 15.974a5.001 5.001 0 0 1 5-4.991zm0 1.997a3 3 0 0 0-3 2.994 3 3 0 0 0 6 0 3 3 0 0 0-3-2.994zm-.555 9.149a1.004 1.004 0 0 1 1.11 0l1.445.962v-2.55a4.983 4.983 0 0 1-2 .422 4.979 4.979 0 0 1-2-.422v2.55l1.445-.962zM15 10.03c.553 0 1 .403 1 .953a.999.999 0 0 1-1 .999H9c-.553 0-1-.447-1-.999 0-.55.447-.953 1-.953h6zM5 7.99c-.553 0-1-.447-1-.998 0-.551.447-.962 1-.962h22c.553 0 1 .411 1 .962a.999.999 0 0 1-1 .998H5z","key":1})]);
}

Diploma332px.displayName = "Diploma332px";

Diploma332px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 25.97"};

module.exports = Diploma332px;

Diploma332px.default = Diploma332px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/32px/diploma-3-32px.svg
// module id = 1094
// module chunks = 0